import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

function formatDate(dateStr: string) {
  const d = new Date(dateStr);
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}

function formatViews(num: number) {
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return num.toString();
}

export default function Home() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 3);
  const latestArticles = articles.slice(0, 6);
  const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 4);

  return (
    <>
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "爆料网",
          url: "http://rbecpr.cn/",
          description: "整合911爆料与91爆料网核心黑料资源，每日实时追踪网红主播塌房现场、明星反差视频与独家吃瓜内容。",
          potentialAction: {
            "@type": "SearchAction",
            target: "http://rbecpr.cn/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "爆料网",
          url: "http://rbecpr.cn/",
          logo: "http://rbecpr.cn/logo.png",
          description: "爆料网是专注于网红主播塌房现场、明星反差视频与独家吃瓜内容的爆料资讯聚合平台。",
        })}
      </script>

      <main>
        {/* ========== HERO SECTION ========== */}
        <section className="relative min-h-[600px] md:min-h-[720px] flex flex-col md:flex-row overflow-hidden">
          {/* Left: Content */}
          <div className="w-full md:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 lg:px-16 py-20 md:py-0">
            <div className="max-w-lg">
              <div className="flex items-center gap-2 mb-6">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                  <i className="ri-fire-fill"></i> 实时追踪
                </span>
                <span className="text-xs text-foreground-400">
                  今日更新 12 条猛料
                </span>
              </div>
              <h1
                className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                网红主播塌房现场
                <br />
                <span className="text-primary-500">独家猛料实时追踪</span>
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                整合911爆料与91爆料网核心黑料资源，每日实时追踪网红主播塌房现场、明星反差视频与独家吃瓜内容。一站式浏览51爆料网、黑料网爆料等热点猛料，你的专属吃瓜基地不打烊。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/influencer"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-md text-sm font-bold hover:bg-foreground-800 transition-colors whitespace-nowrap"
                >
                  浏览热点爆料
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-md text-sm font-medium hover:border-foreground-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  了解爆料网
                </Link>
              </div>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="w-full md:w-1/2 relative min-h-[300px] md:min-h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=dramatic%20breaking%20news%20scene%20with%20red%20and%20black%20color%20scheme%2C%20dark%20moody%20atmosphere%2C%20abstract%20media%20collage%20with%20newspaper%20clippings%20and%20social%20media%20screenshots%2C%20cinematic%20documentary%20style%2C%20high%20contrast%2C%20professional%20newsroom%20aesthetic&width=1200&height=800&seq=hero-main&orientation=landscape"
              alt="爆料网热点追踪"
              className="absolute inset-0 w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50/30 to-transparent md:from-background-50/50"></div>
            {/* Floating stat cards */}
            <div className="absolute bottom-6 left-6 right-6 flex gap-3">
              <div className="bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-3">
                <div className="text-xl font-black text-primary-500">500+</div>
                <div className="text-xs text-foreground-500">每日爆料</div>
              </div>
              <div className="bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-3">
                <div className="text-xl font-black text-primary-500">100万+</div>
                <div className="text-xs text-foreground-500">吃瓜群众</div>
              </div>
              <div className="bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-3 hidden sm:block">
                <div className="text-xl font-black text-primary-500">实时</div>
                <div className="text-xs text-foreground-500">热点追踪</div>
              </div>
            </div>
          </div>
        </section>

        {/* ========== HOT CATEGORIES ========== */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="mb-10">
              <h2
                className="text-2xl md:text-3xl font-black text-foreground-950 mb-2"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                热点爆料分类 <span className="text-primary-500">🔥</span>
              </h2>
              <p className="text-sm text-foreground-500">
                六大爆料分类，覆盖全网最劲爆的瓜
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group relative overflow-hidden rounded-lg bg-background-100 hover:bg-background-200 transition-colors p-5 md:p-6"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                      <i className={`${cat.icon} text-primary-500 text-xl`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center justify-between mb-1">
                        <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-500 transition-colors">
                          {cat.name}
                        </h3>
                        <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full">
                          {cat.articleCount}篇
                        </span>
                      </div>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                        {cat.description}
                      </p>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-arrow-right-line text-primary-500"></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ========== EXCLUSIVE SCANDALS (Feature Grid) ========== */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2
                  className="text-2xl md:text-3xl font-black text-foreground-950 mb-2"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  独家猛料 <span className="text-accent-500">独家</span>
                </h2>
                <p className="text-sm text-foreground-500">
                  爆料网独家调查报道，第一手内幕资料
                </p>
              </div>
              <Link
                to="/category/exclusive"
                className="hidden md:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-700 font-medium whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {exclusiveArticles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className={`group relative overflow-hidden rounded-lg block ${
                    idx === 0 ? "md:col-span-1" : ""
                  }`}
                >
                  <div className="aspect-[3/4] relative">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                        <i className="ri-vip-crown-fill"></i> 独家
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-background-300">
                          {article.category}
                        </span>
                        <span className="text-background-400">·</span>
                        <span className="text-xs text-background-300">
                          {formatDate(article.publishedAt)}
                        </span>
                      </div>
                      <h3 className="text-base md:text-lg font-bold text-background-50 leading-snug group-hover:text-primary-300 transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-sm text-background-300 mt-2 line-clamp-2 hidden md:block">
                        {article.summary}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ========== LATEST ARTICLES (Horizontal Scroll) ========== */}
        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2
                  className="text-2xl md:text-3xl font-black text-foreground-950 mb-2"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  每日最新爆料
                </h2>
                <p className="text-sm text-foreground-500">
                  实时更新，不错过每一条瓜
                </p>
              </div>
              <Link
                to="/category/influencer"
                className="hidden md:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-700 font-medium whitespace-nowrap"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {latestArticles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group block bg-background-100 rounded-lg overflow-hidden hover:shadow-md transition-shadow"
                >
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    {idx === 0 && article.isExclusive && (
                      <div className="absolute top-3 left-3">
                        <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
                          独家首发
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2 text-xs text-foreground-400">
                      <span className="text-primary-500 font-medium">
                        {article.category}
                      </span>
                      <span>·</span>
                      <span>{formatDate(article.publishedAt)}</span>
                      <span>·</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {formatViews(article.views)}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2">
                      {article.summary}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ========== EDITOR'S NOTE ========== */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
              <div className="w-full md:w-3/5">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-1.5 h-1.5 rounded-full bg-foreground-950"></div>
                  <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                    主编寄语
                  </span>
                </div>
                <blockquote
                  className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-relaxed mb-6"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  <span className="text-primary-500 text-4xl">"</span>
                  每一条爆料背后都有真相的轮廓，我们的使命是让吃瓜群众看到最完整的事实拼图，不夸大、不捏造、不缺席。
                </blockquote>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                    <i className="ri-user-3-line text-secondary-700"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">
                      张主编
                    </div>
                    <div className="text-xs text-foreground-400 flex items-center gap-1">
                      爆料网总编辑
                      <i className="ri-checkbox-circle-fill text-green-500"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-2/5">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20editor%20in%20modern%20newsroom%2C%20serious%20expression%2C%20dark%20suit%2C%20dramatic%20side%20lighting%2C%20high%20contrast%20black%20and%20white%20portrait%20style%2C%20editorial%20photography%2C%20newspaper%20editor%20aesthetic&width=600&height=700&seq=editor-portrait&orientation=portrait"
                  alt="爆料网主编"
                  className="w-full rounded-lg object-cover aspect-[4/5]"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ========== HOT TOPICS / TAGS ========== */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <h2
              className="text-xl md:text-2xl font-black text-foreground-950 mb-6"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              热门话题
            </h2>
            <div className="flex flex-wrap gap-2">
              {[
                "911爆料",
                "91爆料网",
                "51爆料网",
                "黑料网爆料",
                "爆料吃瓜网",
                "每日爆料",
                "吃瓜爆料",
                "网红黑料",
                "独家内幕",
                "热点爆料",
                "每日大赛",
                "直播翻车",
                "塌房现场",
                "明星恋情",
                "数据造假",
                "售假打假",
              ].map((tag) => (
                <Link
                  key={tag}
                  to={`/search?q=${encodeURIComponent(tag)}`}
                  className="px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors border border-background-200"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* ========== CTA SECTION ========== */}
        <section className="relative py-20 md:py-28 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=dramatic%20city%20nightscape%20with%20neon%20lights%20and%20urban%20skyline%2C%20dark%20atmospheric%20mood%2C%20red%20and%20orange%20accent%20lights%20reflecting%20on%20wet%20streets%2C%20cinematic%20noir%20style%2C%20breaking%20news%20aesthetic%2C%20high%20contrast%20photography&width=1600&height=600&seq=cta-bg&orientation=landscape"
            alt="爆料网背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="max-w-2xl">
              <h2
                className="text-3xl md:text-4xl lg:text-5xl font-black text-background-50 mb-4 leading-tight"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                有料要爆？
                <br />
                我们24小时在线
              </h2>
              <p className="text-base md:text-lg text-background-300 mb-8 leading-relaxed">
                无论你是知情人、受害者还是吃瓜群众，只要你有真实的爆料内容，爆料网都是你最可靠的发声平台。
              </p>
              <Link
                to="/about#submit"
                className="inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-950 rounded-full text-sm font-bold hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                立即投稿爆料
                <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </span>
              </Link>
            </div>
          </div>
        </section>

        {/* ========== TRENDING / HOT ARTICLES LIST ========== */}
        <section className="py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
            <div className="flex items-end justify-between mb-10">
              <div>
                <h2
                  className="text-2xl md:text-3xl font-black text-foreground-950 mb-2"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  全网热议 <span className="text-primary-500">🔥</span>
                </h2>
                <p className="text-sm text-foreground-500">
                  浏览量最高的爆料内容
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {hotArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group flex gap-4 bg-background-50 rounded-lg p-4 hover:shadow-sm transition-shadow"
                >
                  <div className="w-24 h-24 md:w-28 md:h-28 rounded-md overflow-hidden flex-shrink-0">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1.5 text-xs text-foreground-400">
                      <span className="text-primary-500 font-medium">
                        {article.category}
                      </span>
                      <span>·</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-400"></i>
                        {formatViews(article.views)}
                      </span>
                    </div>
                    <h3 className="text-sm font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug line-clamp-2 mb-1">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-400 line-clamp-2">
                      {article.summary}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
